import {CrudDataList, CrudRepository} from ".";
import Keycloak from "keycloak-js";
import {HelpDirectory} from "../model";
import axios from "redaxios";

export class HelpDirectoryRepository extends CrudRepository<HelpDirectory> {
    constructor(keycloak: Keycloak | null = null) {
        super('help_directories', "PATCH", keycloak)
        this.contentTypes["UPDATE"] = "application/merge-patch+json"
        this.show = this.show.bind(this)
    }

    public show(): Promise<CrudDataList<HelpDirectory>> {
        return new Promise<CrudDataList<HelpDirectory>>((resolve, reject) => {
            axios({
                url:`${process.env.REACT_APP_SERVER_URL}/show/${this.entityCode}`,
                method: 'GET',
                headers: this.headers
            })
                .then((response: any) => {
                    resolve({
                        nbItems: response.data['hydra:totalItems'],
                        data: this.jsonToEntities(
                            response.data['hydra:member']
                        ),
                    });
                })
                .catch((error : any) => {
                    reject(error);
                })
        })
    }

    protected jsonToEntity(json: any): HelpDirectory | null {
        if (!json) return null;
        return {
            id: json.id,
            createdAt: json.createdAt,
            updatedAt: json.updatedAt,
            deletedAt: json.deletedAt,
            name: json.name,
            permission: json.permission,
            helpFiles: json.helpFiles,
            filteredFiles: json.filteredFiles,
            numberOfFiles: json.numberOfFiles,
        }
    }

    protected entityToJson(entity: HelpDirectory): any {
        return super.entityToJson(entity);
    }
}